import { isSameDay, parseISO } from 'date-fns';
import { formatDateFromTodayOnlyDifference } from './formatDateFromTodayOnlyDifference.util';

interface formatPublishHistoryProps {
  approvalDate: string;
  updatedAt?: string | null;
  lastBumpAt?: string | null;
}

export const formatPublishHistory = ({ approvalDate, updatedAt, lastBumpAt }: formatPublishHistoryProps) => {
  if (!approvalDate) {
    return '';
  }

  if (lastBumpAt) {
    return `${formatDateFromTodayOnlyDifference(lastBumpAt)} 끌올`;
  }

  if (!updatedAt) {
    return `${formatDateFromTodayOnlyDifference(approvalDate)} 등록`;
  }

  const parsedApprovalDate = parseISO(approvalDate);
  const parsedUpdatedDate = parseISO(updatedAt);

  const isNotUpdated = isSameDay(parsedApprovalDate, parsedUpdatedDate);

  // 더 최신 날짜를 체크
  const dateToDisplay = isNotUpdated ? approvalDate : updatedAt;
  const suffix = isNotUpdated ? '등록' : '수정';

  return `${formatDateFromTodayOnlyDifference(dateToDisplay)} ${suffix}`;
};
